<template>
    <div>
        <button type="button" class="filter-tag uk-button uk-button-indigo-outline uk-flex uk-flex-middle" @click.stop="removeTag">
            <span>{{ this.type === 'date' ? filterTagText : $t("filters." + filterTagText) }}</span>
            <span class="uk-icon" uk-icon="close"></span>
        </button>
    </div>
</template>

<script>
    export default {
        name: "dr-filter-tag",
        props: ['filterTag', 'filterTagText', 'index', 'type'],
        methods: {
            removeTag() {
                if (this.type === 'checkbox') {
                    this.$store.dispatch('removeCheckedFilters', this.filterTag);
                } else {
                    this.$store.dispatch('removeDateFilters');
                }
            }
        }
    }
</script>

<style lang="scss">

</style>
